import { render } from "./StowingList.vue?vue&type=template&id=b28d3ef4&scoped=true"
import script from "./StowingList.vue?vue&type=script&lang=js"
export * from "./StowingList.vue?vue&type=script&lang=js"

import "./StowingList.vue?vue&type=style&index=0&id=b28d3ef4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b28d3ef4"]])

export default __exports__